const React = require('react')
const PropTypes = require('prop-types')
const hasFeature = require('module/user/helpers/has_feature')
const ref = require('lib/ref')
const log = require('log').create('nav', 'user link'); // eslint-disable-line


class UserLink extends React.Component {

    componentDidMount() {
        this.initializeClipboard()
    }

    componentWillUnmount() {
        this.destroyClipboard()
        this.destroyBubble()
    }

    getHref() {
        const { viewer } = this.context
        if (hasFeature(viewer, 'upgrade') && hasFeature(viewer, 'domain')) {
            const domain = viewer.mapped_domains[0].domain
            return `https://${domain}`
        }

        return `https://about.me/${viewer.user_name}`
    }

    initializeClipboard() {
        log('initializeClipboard')
        require.ensure([], () => {
            const ClipboardJS = require('clipboard')
            const radio = require('lib/radio')
            this.clipboard = new ClipboardJS(this.link, {
                text: () => this.getHref(),
            })
            this.clipboard.on('success', (e) => {
                e.clearSelection()
                radio.metrics.trigger('nav:userlink:copied')
                this.showBubble()
                setTimeout(() => {
                    this.destroyBubble()
                }, 5000)
            })
        }, 'userlink-clipboard')
    }

    showBubble() {
        require.ensure([], () => {
            const Bubble = require('module/bubble/bubble')
            this.bubble = new Bubble({
                html: 'Your page link has been copied.<br>Share it to drive traffic to your page!',
                relativeTo: this.link,
                arrow: false,
                offsetY: 20,
                className: 'bubble-clipboard-success',
            })
        }, 'userlink-clipboard')
    }

    destroyClipboard() {
        if (this.clipboard) this.clipboard.destroy()
    }
    destroyBubble() {
        if (this.bubble) this.bubble.fadeOut()
    }

    render() {
        const { page, viewer } = this.context
        if (page.id !== 'profile') return null

        if (hasFeature(viewer, 'upgrade') && hasFeature(viewer, 'domain')) {
            const domain = viewer.mapped_domains[0].domain
            return (
                <li className="user-link">
                    <span>
                        <span className="domain">about.me</span>
                        <span className="divider"><span className="line">&nbsp;</span></span>
                        <span ref={ref(this, 'link')} className="username text link glyph-share-after">{domain}</span>
                    </span>
                </li>
            )
        }

        return (
            <li className="user-link">
                <span ref={ref(this, 'link')} className="text link">
                    <span className="domain">about.me/</span>
                    <span className="username glyph-share-after">{viewer.user_name}</span>
                </span>
            </li>
        )
    }
}

UserLink.contextTypes = {
    page: PropTypes.object,
    viewer: PropTypes.object,
}

module.exports = UserLink
